import React from 'react';

import DismissibleModuleTutorialPopup from '../../../common/Tutorials/DismissibleModuleTutorialPopup';

function Header() {
  return (
    <header className="relative mb-6 overflow-hidden rounded-xl shadow-md" style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%)' }}>
      <div className="relative z-10 flex items-center justify-between gap-4 p-6 text-white">
        <div className="flex-1">
          <h1 className="mb-1 text-xl font-bold"><span role="img" aria-label="telephone">📞</span> INTERFACE RÉFÉRENT</h1>
          <p className="opacity-90">Prise d'appels entrants, programmation des rendez-vous et affectation des équipes</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => {
              window.alert('Statistiques de la semaine :\n\n• RDV pris : 15\n• RDV effectués : 12\n• Taux de réussite : 80%\n• Équipe Transaction : 13 RDV\n• Équipe Location : 8 RDV');
            }}
            className="rounded-lg border border-white/30 bg-white/20 px-3 py-2 text-white backdrop-blur transition hover:bg-white/30"
          >
            <span role="img" aria-label="stats">📊</span> Statistiques
          </button>
          <DismissibleModuleTutorialPopup
            tutorial="referent-appointments"
            label="Guide d'utilisation"
            containerClassName=""
            renderTrigger={(open) => (
              <button
                type="button"
                onClick={open}
                className="rounded-lg border border-white/30 bg-white/20 px-3 py-2 text-white backdrop-blur transition hover:bg-white/30"
              >
                <span role="img" aria-label="book">📚</span> Guide d'utilisation
              </button>
            )}
          />
        </div>
      </div>
    </header>
  );
}

export default Header;


